import React, { useState } from "react";
// import "../../../../assets/css/employee_manual.css"; // Ensure you have appropriate styling in App.css

const menuItems = [
    {
        title: "Sign In",
        subItems: [
            { id: "Sign In-step1", text: "Step 1 - Visit Paydocs website", image: "1.png" },
            { id: "Sign In-step2", text: "Step 2 - Email from Paydocs", image: "2.png" },
            { id: "Sign In-step3", text: "Step 3 - Enter Credentials", image: "3.png" },
            { id: "Sign In-step4", text: "Step 4 - Dashboard", image: "9.png" },
            { id: "Sign In-step5", text: "Step 5 - Profile", images: ["11.png", "12.png"] },
            { id: "Sign In-step6", text: "Step 6 - Change Password", images: ["11.png", "13.png"] },
            { id: "Sign In-step7", text: "Step 7 - Sign Out", image: "11.png" },
        ],
    },
    { title: "Punch In/Out", id: "Punch In/Out", image: "10.png" },
    { title: "Employees", id: "Employees", images: ["14.png", "15.png"] },
    {
        title: "Time Sheet",
        subItems: [
            { id: "Time Sheet-step1", text: "Time Entry", image: "32.png" },
            { id: "Time Sheet-step2", text: "Leave Entry", image: "36.png" },
            { id: "Time Sheet-step3", text: "Time Approval", image: "46.png" },
            { id: "Time Sheet-step4", text: "Leave Approval", image: "49.png" },
        ],
    },
    {
        title: "Expenses",
        subItems: [
            { id: "Expenses-step1", text: "Expenses Entry", image: "16.png" },
            { id: "Expenses-step2", text: "Expenses Approvals", image: "19.png" },
        ],
    },
    {
        title: "Payroll",
        subItems: [
            { id: "Payroll-step1", text: "Payroll Components", image: "24.png" },
            { id: "Payroll-step2", text: "Payslip", image: "25.png" },
        ],
    },
    {
        title: "Savings",
        subItems: [
            { id: "Savings-step1", text: "New Regime", image: "26.png" },
            { id: "Savings-step2", text: "Old Regime", images: ["26.png", "27.png", "28.png", "29.png", "30.png", "31.png"] },
        ],
    },
];

const UserManual = () => {
    const [activeContent, setActiveContent] = useState("Welcome");
    const [openMenus, setOpenMenus] = useState({});
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleMenu = (title) => {
        setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
    };

    return (
        <div className="app-container">
            <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
                ☰
            </button>
            <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
                {menuItems.map((menu) => (
                    <div key={menu.title}>
                        <div className="menu-item" onClick={() => (menu.subItems ? toggleMenu(menu.title) : setActiveContent(menu.id))}>
                            {menu.title}
                        </div>
                        {menu.subItems && openMenus[menu.title] && (
                            <div className="submenu">
                                {menu.subItems.map((sub) => (
                                    <div key={sub.id} className="submenu-item" onClick={() => setActiveContent(sub.id)}>
                                        {sub.text}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="content">
                {activeContent === "Welcome" ? (
                    <h2>Welcome to Paydocs User Guide</h2>
                ) : (
                    <div>
                        <h2>{activeContent.replace(/-/g, " ")}</h2>
                        {menuItems.flatMap(menu => menu.subItems || [menu]).map(item =>
                            item.id === activeContent && (item.images ?
                                item.images.map(img => <img key={img} src={`/assets/images/${img}`} alt={activeContent} style={{ maxWidth: "800px", height: "400px", marginBottom: "15px" }} />)
                                : <img src={`/assets/images/${item.image}`} alt={activeContent} style={{ maxWidth: "800px", height: "400px", marginBottom: "15px" }} />
                            )
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserManual;